import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Section, SectionHeading } from "@/components/Section";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="page-wrapper pt-32 md:pt-40" data-testid="news-page">
      <Section>
        <SectionHeading
          overline="Dispatches"
          title="Whispers from the writing room."
          kicker="Cover reveals, release dates, craft essays, and the occasional confession."
        />

        <div className="space-y-8">
          {posts.length === 0 ? (
            <motion.div
              data-testid="news-empty-state"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center py-24 md:py-32 border border-[#D4AF37]/5 rounded-2xl bg-[#2B3A4A]"
            >
              <div className="overline mb-6">Quiet, for now</div>
              <h3 className="font-serif text-3xl md:text-4xl text-[#F4F4F6] font-light leading-tight mb-6 max-w-2xl mx-auto px-6">
                The writing room is dark and the stars are listening.
              </h3>
              <p className="text-[#A0A4AE] text-base max-w-md mx-auto px-6 mb-10">
                More dispatches coming soon. In the meantime, join The Letter to be the first to hear when news drops.
              </p>
              <a href="/#newsletter" data-testid="news-empty-cta" className="btn-primary">
                Join The Letter →
              </a>
            </motion.div>
          ) : (
            posts.map((post, i) => (
              <motion.article
                key={post.id}
                data-testid={`news-list-${post.slug}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="border-b border-[#D4AF37]/5 pb-8"
              >
                <Link
                  to={`/news/${post.slug}`}
                  className="grid grid-cols-1 md:grid-cols-12 gap-8 group cursor-pointer"
                >
                  <div className="md:col-span-4 aspect-[16/10] md:aspect-[4/3] overflow-hidden rounded-xl">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                    />
                  </div>
                  <div className="md:col-span-8 flex flex-col justify-center">
                    <div className="overline mb-4">{post.category} · {post.date}</div>
                    <h2 className="font-serif text-3xl md:text-4xl text-[#F4F4F6] font-light leading-tight mb-4 group-hover:text-[#D4AF37] transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-[#A0A4AE] text-base leading-relaxed max-w-2xl">
                      {post.excerpt}
                    </p>
                    <span className="overline mt-5 text-[#D4AF37]">Read more →</span>
                  </div>
                </Link>
              </motion.article>
            ))
          )}
        </div>
      </Section>
    </div>
  );
}
